import { Component, Input } from '@angular/core';
import { ZoningCode, ZoningCodeVersion } from 'src/app/modules/instance/models';
import { JobsService } from 'src/app/modules/instance/services';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { switchMap, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import * as _ from 'lodash';
import { ZoningCodeVersionButtons } from 'src/app/modules/instance/models';
import { TaskType } from 'src/app/shared';

@Component({
    standalone: false,
    selector: 'app-zoning-code-version-delete-button',
    templateUrl: './zoning-code-version-delete-button.component.html',
    styleUrls: ['./zoning-code-version-delete-button.component.scss']
})
export class zoningCodeVersionDeleteButtonComponent extends ZoningCodeVersionButtons {
    constructor(
        private readonly jobsService: JobsService,
        private readonly dialog: MatDialog,
        private readonly snackBar: MatSnackBar
    ) {
        super();
    }

    @Input()
    public zoningCode: ZoningCode;

    @Input()
    public zoningCodeVersion: ZoningCodeVersion;

    public deleteZCVersion(event: Event) {
        event.stopPropagation();

        if (
            !this.zoningCodeVersion.Id ||
            !this.zoningCodeVersion.ActualVersion ||
            !this.zoningCode.Id ||
            !this.zoningCode.Name
        ) {
            return;
        }

        const dialogConfig = new MatDialogConfig();

        const title = 'Clear Zoning Code Version results';
        const topContent = `<p>If you continue, a <b>Remove Zoning Code Version Calculation Results</b> job will be created and started, removing all calculation results for <b>${this.zoningCode.Name}</b>, Version <b>${this.zoningCodeVersion.ActualVersion}</b>.</p>
<p class="small-italic-text">*If this is an old version of the Zoning Code, the version will also be removed.</p>
     `;

        dialogConfig.autoFocus = true;
        dialogConfig.data = { title, topContent, yesButtonLabel: 'Continue', noButtonLabel: 'Cancel' };
        dialogConfig.maxHeight = '600px';
        dialogConfig.maxWidth = '450px';

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        dialogRef
            .afterClosed()
            .pipe(
                filter(isConfirm => isConfirm),
                switchMap(() => {
                    if (this.zoningCodeVersion.hasTasks) {
                        this.snackBar.open(
                            'First you must delete all tasks for the selected Zoning Code Version.',
                            'OK',
                            {
                                verticalPosition: 'top',
                                horizontalPosition: 'center',
                                duration: 4000
                            }
                        );

                        return of(null);
                    }

                    return this.jobsService.addJob(TaskType.REMOVE_ZCV_CRS_JOB, {
                        name: `${this.zoningCode.Name}, Actual Version ${this.zoningCodeVersion.ActualVersion}, Version Id ${this.zoningCodeVersion.Id}`,
                        doNotRun: false,
                        zcVersionId: this.zoningCodeVersion.Id
                    });
                }),
                // This is needed to handle snackbar if ZCV has processes that should be removed
                filter(removalStatistic => !!removalStatistic)
            )
            .subscribe(
                () => {
                    this.zoningCodeVersion.setDeletionStatus(true);
                    this.snackBar.open(
                        'Remove Zoning Code Version Calculation Results Job was successfully created',
                        'OK',
                        {
                            verticalPosition: 'top',
                            horizontalPosition: 'center',
                            duration: 4000
                        }
                    );
                },
                error => {
                    this.snackBar.open(error.error.messages[0], 'OK', {
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 2000
                    });
                }
            );
    }
}
